import { createSlice } from '@reduxjs/toolkit';


const chainSiteSelectorSlice = createSlice({
  name: 'doris',
  initialState: {
    selectedChain: '',
    selectedSite: '',
    preferredLanguage: 'en',
    isLoadingChains: true,
    isLoadingSites: true,
    isLoading: true,
    error: false,
  },
  reducers: {
    loadingChains(state) {
      state.isLoadingChains = true;
    },
    loadedChains(state) {
      state.isLoadingChains = false;
    },
    loadingSites(state) {
      state.isLoadingSites = true;
    },
    loadedSites(state) {
      state.isLoadingSites = false;
    },
    selectChain(state, action) {
      state.selectedChain = action.payload;
    },
    selectSite(state, action) {
      state.selectedSite = action.payload;
    },
    setLanguage(state, action) {
      state.preferredLanguage = action.payload;
    }
  }
});

export const {
  loadingChains,
  loadedChains,
  loadingSites,
  loadedSites,
  selectChain,
  selectSite,
  setLanguage
} = chainSiteSelectorSlice.actions;

export default chainSiteSelectorSlice.reducer;